import { createContext, useContext } from "react";
import {
  IMarketCampaignBasicInfo,
  IMarketCampaignChannel,
  IMarketCampaignDraftStep,
  initialMarketCampaignState,
} from "../../redux/marketCampaign/marketCampaign.types";

export interface IProviderCampaignState {
  marketCampaign: IMarketCampaignBasicInfo;
  draftSteps: IMarketCampaignDraftStep;
  campaignChannel: IMarketCampaignChannel;
  completionSteps: {
    step1: boolean;
    step2: boolean;
    step3: boolean;
    // step4: boolean;
  };
  activeStep: number;
  maxAllowedSteps: number;
}

interface IMarketCampaignContext extends IProviderCampaignState {
  state: IProviderCampaignState;
  isEditable: boolean;
  isCompleted: boolean;
  isAutoGenerating: boolean;
  isReadyToExecution: boolean;
  isAutoGenerationFailed: boolean;
  onKeyChange: <K extends keyof IProviderCampaignState>(
    key: K,
    value: IProviderCampaignState[K],
  ) => void;
  onStateChange: (state: IProviderCampaignState) => void;
}

export const defaultProviderCampaignState: IProviderCampaignState = {
  marketCampaign: initialMarketCampaignState["marketCampainBasicInfo"]["data"],
  draftSteps: initialMarketCampaignState["marketCampaignDraftSteps"]["data"],
  campaignChannel: initialMarketCampaignState["marketCampaignChannel"]["data"],
  completionSteps: {
    step1: false,
    step2: false,
    step3: false,
    // step4: false,
  },
  activeStep: 0,
  maxAllowedSteps: 0,
};

export const MarketCampaignContext = createContext<
  IMarketCampaignContext | undefined
>(undefined);

export const useMarketCampaignContext = () => {
  const context = useContext(MarketCampaignContext);
  if (!context) {
    throw new Error(
      "useMarketCampaignContext must be used within a MarketCampaignProvider",
    );
  }
  return context;
};
